import type { Resource } from '../../';
export const general_errors_renderAlerts_title_inRenderProd: Resource = {"default":"Encountered a render error."};
